module.exports = __webpack_public_path__ + "825237ef833e080c14a36648149bab24.svg";